import React, { useEffect, useState } from "react";
import TweetList from './TweetList';
import Header from './Header';
import { useTwitterContext } from '../TwitterContext';
import UserInfo from './UserInfo';
import { useParams } from "react-router-dom";
import '../style/App.css';
import Translate from './Translate';

const Profile = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [isCurUser, setIsCurUser] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { accessToken, curUser } = useTwitterContext();
  const [imgPreview, setImgPreview] = useState("");
  const [filter, setFilter] = useState("user");

  useEffect(() => {
    async function getUser() {
      if (curUser && Number(id) === Number(curUser.id)) {
        setIsCurUser(true);
      } else {
        setIsCurUser(false);
      }
      // make a call to our API to verify the user in our database, if it doesn't exist we'll insert it into our database
      // finally we'll redirect the user to the /app route
      const data = await fetch(`${process.env.REACT_APP_API_URL}/users/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const userData = await data.json();
      setUser(userData);
      setFilter({user: userData.id});
    }
    if (!isEditing) {
      getUser(); 
    }
  }, [id, isEditing, curUser]);

  const Description = () => {
    if (user.description === null) {
      return <p className="description">No description</p>;
    }
    return (
      <div>
        <p className="description">{user.description}</p>
        <Translate text={user.description}/>
      </div>
    );
  }

  const SwitchEditPanel = () => {
    setImgPreview(user.avatar);
    setIsEditing(!isEditing);
    if (isEditing) {
      if (user.description === null) {
        user.description = "No Description";
      }
      if (user.avatar === "https://www.repol.copl.ulaval.ca/wp-content/uploads/2019/01/default-user-icon.jpg") {
        user.avatar = "";
      }
    }
  }

  async function EditProfile() {
    const updatedName = document.querySelector("#edit-user-name").value;
    const updatedAvatar = document.querySelector("#edit-user-avatar").value;
    const updatedDescription = document.querySelector("#edit-description").value;
    if (updatedName === "") {
      alert("Name cannot be empty!");
      return ;
    }
     await fetch(`${process.env.REACT_APP_API_URL}/users/${user.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        name: updatedName,
        description: updatedDescription,
        avatar: updatedAvatar,
      }),
    });
    setIsEditing(false);
  }

  const HandleAvatarChange = () => {
    const updatedAvatar = document.querySelector("#edit-user-avatar").value;
    setImgPreview(updatedAvatar);
    user.avatar = updatedAvatar;
  }
    
  const UserInfoPanel = () => {
    if (user === null) {
      return null;
    }
    if (isEditing) {
      return (
        <div className="profile">
          <div className="edit-panel-item">
            <img src={imgPreview} className="avatar" alt="avatar" />
          </div>
          <div className="edit-panel-item">
            <label className="edit-panel-label">Name</label>
            <input className="edit-panel-input" type="text" defaultValue={user.name} id="edit-user-name" />
          </div>
          <div className="edit-panel-item">
            <label className="edit-panel-label">Avatar</label>
            <input className="edit-panel-input" type="text" defaultValue={user.avatar} id="edit-user-avatar" />
          </div>
          <div className="edit-panel-item">
            <button className="edit-profile-button" onClick={HandleAvatarChange}>Preview</button>
          </div>
          <div className="edit-panel-item">
            <label className="edit-panel-label">Description</label>
            <input className="edit-panel-input" type="text" defaultValue={user.description} id="edit-description"/>
          </div>
          <button className="edit-profile-button" onClick={EditProfile}>Save</button>
        </div>
      );
    }
    if (isCurUser) {
      return (
        <div className="profile">
          <UserInfo info={user} />
          <Description />
          <button className="edit-profile-button" onClick={SwitchEditPanel}>Edit</button>
        </div>
      );
    }
    return (
      <div className="profile">
        <UserInfo info={user} />
        <Description />
      </div>
    );
  }

  return (
    <div className="content-container">
      <Header />
      <div className="App">
        <UserInfoPanel />
        <TweetList filter={filter}/>
      </div>
    </div>
  );
};

export default Profile;